import { inject, Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { InjectionTokens } from '@src/serviceTokens';
import { Observable, tap } from 'rxjs';
import { LoginService } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  protected loginService: LoginService = inject(InjectionTokens.get(LoginService));

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canLoad();
  }

  canLoad(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.loginService.checkAuth$.pipe(
      tap(val => {
        if (!val) {
          if (this.loginService.user) {
            this.loginService.logOut('/');
          }
          this.loginService.login(window.location.pathname);
        }
      })
    );
  }
}
